import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    eventData:{},
    numberOfTickets: [],
    FormDataEvent:[],
    FormDataRequiredFields:[],
    registrationForm:[{}],
    products:[],
    varients:{},
    selectedValue:[],
    previousSelectedValue:[],
    currentSelectIndex: "",
    FormDataReservation:[],
    ticketsData:[],
    ticketTypeList:[],
    ticketTypeVariants:[],
    
};

export const eventsSlice = createSlice({
    name: "events",
    initialState,
    reducers: {
        setCounterTicket: (state, payload ) => {
            state.numberOfTickets =  payload.payload;
            return state;
        },
        setTicketsData: (state, payload ) => {
            state.ticketsData =  payload.payload;
            return state;
        },
        setEventData: (state,  {payload} ) => {
            state.eventData = payload;
            return state;
        },
        setFormReservationData: (state,  {payload} ) => {
            state.FormDataEvent = payload;
            return state;
        },
        setForms: (state,  {payload} ) => {
            state.registrationForm =payload;
            return state;
        },
        setResetForms: (state,  {payload} ) => {
            state.registrationForm = [];
            return state;
        },
        setFormDataRequiredFields: (state,  {payload} ) => {
            state.FormDataRequiredFields = payload;
            return state;
        },
        setProducts: (state,  {payload} ) => {
            return {...state ,products :payload};
            
        },
        setTotalProducts: (state,  {payload} ) => {
            return {...state ,totalProducts :payload};
            
        },
        setHideCards: (state,  {payload} ) => {
            return {...state ,hideRightCards :payload};
            
        },
        setVarients: (state, action) => {
            return {...state ,varients :action.payload};
        },
        setVarientPrice: (state, action) => {
            const { productIndex, price } = action.payload;
            state.varients = {
                ...state.varients,
                [productIndex]: {
                    ...state.varients[productIndex],
                    price
                }
            };
            return state;
        },
        setSelectedValue: (state,  action ) => {
            const {data,productIndex,productTitle,dropdownIndex,type,ticketIndex} = action.payload
            state.selectedValue = data;
            // find the object depends on dropdownIndex and ticketIndex we need it to change on varients counter value depends on productIndex
            const selectedValueIndex =  state.selectedValue?.map((item)=>{
                return item[productTitle]?.find((item)=>item.indexSelected === dropdownIndex && item.ticketIndex === ticketIndex)
            })
            const changeQuantity = data && state?.varients?.[productIndex]?.variantsInfo?.map((varient)=>{
                // check if the object value  is equal to the option one and update counterValue 
                if(varient.option === selectedValueIndex[0]?.value && type !== 'remove'){
                    return { ...varient, counterValue : varient?.counterValue + 1};
                    // minas from counterValue if the type is remove (came from ticket inside decrement button) if the user remove one of the dropdowns
                }else if(varient.option === selectedValueIndex[0]?.value && type === 'remove'){
                    return { ...varient, counterValue : varient?.counterValue - 1}; 
                }
                // if we have previousValue inside selectedValueIndex object 
                else if (selectedValueIndex[0]?.previousValue){
                    // check if this previousValue  is same as Varient Option then mines counterValue value from array from object
                    if(selectedValueIndex[0]?.previousValue === varient?.option ){
                        return { ...varient, counterValue :varient?.counterValue >0 ? varient?.counterValue - 1:varient?.counterValue}; 
                    }else{    
                        return { ...varient}; 
                    }
                    // if we have no match just return the item as it is
                    }else{    
                        return { ...varient}; 
                    }
                }
            )
            // Replace the product with new array of products after adding/removing a variant
            const replaceOldData ={...state?.varients,[productIndex] : {...state.varients?.[productIndex],variantsInfo:changeQuantity}}
            state.varients = changeQuantity ? replaceOldData : state?.varients;
            return state;
        },
        setFormDataReservation:(state,action)=>{
            return {...state ,FormDataReservation :action.payload};
        },
        resetAction: (state) => {
            return {...state,selectedValue:[],FormDataReservation:[]};
        },
        setCurrentSelectIndex: (state, payload) => {
            state.currentSelectIndex = payload.payload;
            return state;
        },
        setTicketTypeList: (state, payload) => {
            state.ticketTypeList = payload.payload;
            return state;
        },
        setTicketTypeVariants: (state, payload) => {
            state.ticketTypeVariants = payload.payload;
            return state;
        },
    },
});

export const { setCounterTicket,setCurrentSelectIndex, setTicketTypeList,setTicketTypeVariants } = eventsSlice.actions;
export default eventsSlice.reducer;
